import React, { useState, useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';
import { Button } from './ui/button';

const WhatsAppButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const whatsappNumber = "243999006868"; // Numéro WhatsApp GOS MÉDIA (sans le +)
  const message = "Bonjour GOS MÉDIA, j'aimerais avoir plus d'informations sur vos services.";

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
      // Show tooltip after 3 seconds
      setTimeout(() => setShowTooltip(true), 500);
      // Hide tooltip after 8 seconds
      setTimeout(() => setShowTooltip(false), 8000);
    }, 2000);

    return () => clearTimeout(timer);
  }, [setIsVisible, setShowTooltip]);

  const handleWhatsAppClick = () => {
    const url = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
    setShowTooltip(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-8 right-8 z-50">
      {/* Tooltip */}
      {showTooltip && (
        <div className="absolute bottom-full right-0 mb-4 animate-slide-up">
          <div className="bg-white rounded-2xl shadow-2xl p-4 pr-10 max-w-xs relative">
            <button
              onClick={() => setShowTooltip(false)}
              className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 transition-colors"
            >
              <X className="h-4 w-4" />
            </button>
            <p className="text-sm text-gray-700 font-medium">
              Besoin d'aide ? 👋
            </p>
            <p className="text-xs text-gray-500 mt-1">
              Discutez avec nous sur WhatsApp
            </p>
          </div>
          <div className="w-4 h-4 bg-white transform rotate-45 absolute -bottom-2 right-8"></div>
        </div>
      )}

      {/* WhatsApp Button */}
      <Button
        onClick={handleWhatsAppClick}
        className="group h-16 w-16 rounded-full bg-green-500 hover:bg-green-600 shadow-2xl hover:shadow-green-500/50 transition-all duration-300 hover:scale-110 p-0 animate-bounce-slow"
        style={{
          animation: 'bounce-slow 2s ease-in-out infinite'
        }}
      >
        <MessageCircle className="h-8 w-8 text-white group-hover:scale-110 transition-transform" />
      </Button>

      {/* Pulse Effect */}
      <div className="absolute inset-0 rounded-full bg-green-500 animate-ping opacity-20 pointer-events-none"></div>
    </div>
  );
};

export default WhatsAppButton;
